<template>
  <div class="qualitycheck-list">
    <v-card>

        <v-app-bar flat >
          <v-icon>mdi-bug-check</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('qualitycheck.qualitycheck.checks')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-if="userHasAccess('qualitycheck_edit')"
                  @click="addHandler"
                >
                  <v-list-item-title>{{$t('global.add')}}</v-list-item-title>

                </v-list-item>

              </v-list>
            </v-menu>
        </v-app-bar>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
:items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
          :loading="isLoading"
          :loading-text="$t('global.loading')"
          :options.sync="options"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="@id"
          @update:options="onUpdateOptions"
          @click:row="editHandler"
        >
              <template slot="item.start" slot-scope="{ item }">
                {{ formatDate(item['start'], 'long') }}
              </template>
              <template slot="item.end" slot-scope="{ item }">
                {{ formatDate(item['end'], 'long') }}
              </template>
              <template slot="item.success" slot-scope="{ item }">
                <span v-if="item['success']"  ><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else><v-icon color="red">mdi-close-circle</v-icon></span>
              </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
//import moment from 'moment';
export default {
  name: 'QualityCheckList',
  servicePrefix: 'QualityCheck',
  mixins: [ListMixin,AccessMixin],
  components: {


  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.qualitycheck.product'), value: 'product.name' },
        { text: this.$t('qualitycheck.qualitycheck.name'), value: 'name' },
        { text: this.$t('qualitycheck.qualitycheck.usertesting'), value: 'userTesting.nom' },
        { text: this.$t('qualitycheck.qualitycheck.start'), value: 'start' },
        { text: this.$t('qualitycheck.qualitycheck.end'), value: 'end' },
        { text: this.$t('qualitycheck.qualitycheck.success'), value: 'success' },

      ],
      filters: {
        'success' : false,
        'exists[end]' :  false ,
        //'end_after' :  moment(new Date()).format('YYYY-MM-DD') ,
      },
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['start'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('qualitycheck', {
      items: 'list'
    }),
    ...mapFields('qualitycheck', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('qualitycheck', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
